import { NavLink } from "react-router";

import { effectiveRole, isOrgAdmin, isPlatformAdmin } from "../lib/scopes";
import IdentityBadge from "./IdentityBadge";

interface Props {
  onLogout: () => void;
}

interface NavItem {
  to: string;
  label: string;
  show: () => boolean;
}

const NAV: NavItem[] = [
  { to: "/overview", label: "Overview", show: () => true },
  { to: "/me", label: "Eigene Kosten", show: () => true },
  { to: "/realms", label: "Realms", show: () => true },
  { to: "/packs", label: "Packs", show: () => true },
  { to: "/organizations", label: "Organizations", show: () => isOrgAdmin() },
  { to: "/providers", label: "Provider-Health", show: () => isPlatformAdmin() },
  { to: "/records", label: "Records", show: () => true },
];

export default function Sidebar({ onLogout }: Props) {
  const role = effectiveRole();
  return (
    <aside className="bg-kw-bg-elevated border-r border-kw-border-subtle p-4 flex flex-col gap-2">
      <div className="px-2 py-3">
        <div className="text-kw-l3 font-mono text-sm">kw://cost</div>
        <div className="text-xs text-kw-text-faint mt-1">{role}</div>
      </div>
      <nav className="flex flex-col gap-1 mt-2">
        {NAV.filter((item) => item.show()).map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `px-3 py-2 rounded text-sm ${
                isActive
                  ? "bg-kw-l3 text-white"
                  : "text-kw-text-primary hover:bg-kw-bg-overlay"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="mt-auto pt-4 border-t border-kw-border-subtle space-y-2">
        <div className="px-3">
          <IdentityBadge />
        </div>
        <button
          onClick={onLogout}
          className="w-full px-3 py-2 text-sm text-kw-text-muted hover:text-kw-text-primary"
        >
          Abmelden
        </button>
      </div>
    </aside>
  );
}
